import config from "../config";

// e.g. https://d1uy1wopdv0whp.cloudfront.net/newsimages/news_ (month + year + "/" follow)
const NEWS_IMG_BASE = config.AWS_IMG_URL;
const UPLOAD_IMAGE_REGEX = /\/uploads\/(\d{13})(?:_[^/.]*)?\.(?:png|jpe?g|webp)(?:\?.*)?$/i;
const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

// https://uatads.way2news.com/uploads/1792454895629_533.png
//   -> https://d1uy1wopdv0whp.cloudfront.net/newsimages/news_102026/1792454895629_533-full-WIFI.webp
// Anything that doesn't look like an upload image (gif, video, other hosts) is returned unchanged.
export const constructImageUrl = (url, size = "full") => {
  if (typeof url !== "string") return url;
  const match = url.match(UPLOAD_IMAGE_REGEX);
  if (!match) return url;
  const fileName = url.split("?")[0].split("/").pop().replace(/\.[^.]+$/, "");
  const date = new Date(Number(match[1]) + IST_OFFSET_MS);
  const month = date.getUTCMonth() + 1;
  return `${NEWS_IMG_BASE}${month}${date.getUTCFullYear()}/${fileName}-${size}-WIFI.webp`;
};

// Promoted story previews use the smaller "normal" rendition.
const NORMAL_SIZE_SUB_TYPES = ["promoted_image_story", "promoted_video_story", "promoted_gallery"];

// Comment, brand/magazine, classified, recommended and widget ads: the backend
// keeps only the file name in the redis object and prefixes a fixed CDN folder.
const BRAND_AD_BASE = config.AWS_BRAND_AD_URL;
const COMMENT_AD_BASE = config.AWS_COMMENT_AD_URL;
const FILE_NAME_BASES = {
  commentad: COMMENT_AD_BASE,
  search: BRAND_AD_BASE,
  unread: BRAND_AD_BASE,
  news_image_flip: BRAND_AD_BASE,
  news_image_logo: BRAND_AD_BASE,
  news_short_desc: BRAND_AD_BASE,
  video_expandable: BRAND_AD_BASE,
  video_endcard: BRAND_AD_BASE,
  video_skippable: BRAND_AD_BASE,
  bottom_rectangle: BRAND_AD_BASE,
  square_classified: BRAND_AD_BASE,
  rectangle_classified: BRAND_AD_BASE,
  rec_image: BRAND_AD_BASE,
  rec_promoted_story: BRAND_AD_BASE,
  job_listings: BRAND_AD_BASE,
  business_listings: BRAND_AD_BASE,
  specials: BRAND_AD_BASE,
};

// Only our own upload hosts are rewritten, same as the backend's host check.
const constructFileNameUrl = (url, base) =>
  typeof url === "string" && url.includes("ads.way2news.com")
    ? base + url.split("?")[0].split("/").pop()
    : url;

const convertEntry = (entry, convert) =>
  entry && typeof entry === "object" && entry.image
    ? { ...entry, image: convert(entry.image) }
    : convert(entry);

// Returns a copy of the preview with img_urls and gallery (arrays of urls or
// { image } objects) rewritten to CDN urls.
export const withConstructedImages = (preview) => {
  if (!preview || (!preview.img_urls && !preview.gallery && !preview.video_urls)) return preview;
  const fileNameBase = FILE_NAME_BASES[preview.sub_type];
  const size = NORMAL_SIZE_SUB_TYPES.includes(preview.sub_type) ? "normal" : "full";
  const convert = fileNameBase
    ? (u) => constructFileNameUrl(u, fileNameBase)
    : (u) => constructImageUrl(u, size);
  const result = { ...preview };
  if (preview.img_urls) {
    result.img_urls = Array.isArray(preview.img_urls)
      ? preview.img_urls.map((u) => convertEntry(u, convert))
      : convert(preview.img_urls);
  }
  // gallery is an object (not a list) for some sub types, e.g. specials
  if (Array.isArray(preview.gallery)) {
    result.gallery = preview.gallery.map((u) => convertEntry(u, convert));
  }
  // specials use video_urls as the banner image; other video urls stay as they are
  if (preview.sub_type === "specials" && typeof preview.video_urls === "string") {
    result.video_urls = convert(preview.video_urls);
  }
  return result;
};
